<ion-app>
  <ion-router-outlet [animated]="ionRouterOutletAnimated"></ion-router-outlet>
</ion-app>
